import React, { ReactNode, Ref, forwardRef } from 'react';
import css from './Button.module.css';
import clsx from 'clsx';
import { ButtonType } from './ButtonType';

export interface ButtonPropsExt {
  tooltip?: string;
  disabled?: boolean;
  onClick?: () => void;
  buttonType?: ButtonType;
}

export interface ButtonProps extends ButtonPropsExt {
  className?: string;
  children: ReactNode;
}

const ButtonComponent: React.ForwardRefRenderFunction<
  HTMLButtonElement,
  ButtonProps
> = (props: ButtonProps, ref: Ref<HTMLButtonElement>) => {
  const { disabled = false, buttonType = ButtonType.Primary } = props;
  const onClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (props.onClick) {
      event.stopPropagation();
      props.onClick();
    }
  };
  return (
    <div className={clsx(css.selectionBorder)}>
      <button
        ref={ref}
        className={clsx(
          props.className,
          css.button,
          buttonType === ButtonType.Primary ? css.primaryButton : '',
          buttonType === ButtonType.Secondary ? css.secondaryButton : '',
          buttonType === ButtonType.Tertiary ? css.tertiaryButton : ''
        )}
        type="button"
        onClick={onClick}
        disabled={disabled}
        title={props.tooltip}
      >
        {props.children}
      </button>
    </div>
  );
};

const Button = forwardRef(ButtonComponent);

export default Button;
